/**
 * REACT_APP_<FEATURE>_API build-time flags.
 *
 * - unset or "live" → real HTTP (production default)
 * - "mock"          → offline fixtures for local dev / Storybook
 */
export const isMockApiFlag = (value: string | undefined): boolean =>
  value === "mock";

export const isLiveApiFlag = (value: string | undefined): boolean =>
  !isMockApiFlag(value);
